module.exports = __webpack_public_path__ + "img/touxiang.6940ff45.png";